import Vue from 'vue';
import store from './store/index.js';

import HomepageSearch from './HomepageSearch.vue';
Vue.component('homepage-search', HomepageSearch );

if (typeof window.preloadedLocationData !== 'undefined' && typeof window.preloadedLocationData.d !== 'undefined' && window.preloadedLocationData.d.length > 0) {
    store.commit('SearchOptions/setUsedDealers', window.preloadedLocationData.d);
} else {
    console.error('UsedDealer data missing');
}

const app = new Vue({
    el: document.getElementById('homepageSearch'),
    data: {},
    store,
    created: function () {
        this.$store.dispatch('CustomerData/initialize');
    },
});